import { GUIDE_VIEW_FILTERING } from '@/components/Guide';
import { tableConfig } from '@/features/i18n/table.config';
import { EyeOff, Filter as FilterIcon, Plus, Settings } from '@/components/icons';
import type { CalendarView } from '@/sdk';
import { CreateRecordModal, ViewFilter, VisibleFields } from '@/sdk';
import { useHookPermission } from '@/sdk/hooks/use-hook-permission';
import { useView } from '@/sdk/hooks/use-view';
import { Button, cn } from '@/ui-lib/shadcn';
import { useTranslation } from 'react-i18next';
import { CalendarConfig } from '../../calendar/components/CalendarConfig';
import { useToolbarChange } from '../../hooks/useToolbarChange';
import { ToolBarButton } from '../ToolBarButton';

export const CalendarViewOperators: React.FC<{ disabled?: boolean }> = (props) => {
  const { disabled } = props;
  const view = useView() as CalendarView | undefined;
  const permission = useHookPermission();
  const { t } = useTranslation(tableConfig.i18nNamespaces);
  const { onFilterChange } = useToolbarChange();

  if (!view) return null;

  return (
    <div className="flex items-center gap-2">
      <CreateRecordModal>
        <Button
          className="size-6 shrink-0 rounded-full p-0"
          size={'xs'}
          variant={'outline'}
          disabled={!permission['record|create']}
        >
          <Plus className="size-4" />
        </Button>
      </CreateRecordModal>
      <div className="mx-2 h-4 w-px shrink-0 bg-slate-200" />
      <CalendarConfig>
        <ToolBarButton
          disabled={disabled}
          isActive={false}
          text={t('table:calendar.toolbar.config')}
          textClassName="@2xl/toolbar:inline"
        >
          <Settings className="size-4 text-sm" />
        </ToolBarButton>
      </CalendarConfig>
      <VisibleFields>
        {(_text, _isActive) => (
          <ToolBarButton
            disabled={disabled}
            isActive={false}
            text={t('sdk:hidden.label')}
            textClassName="@2xl/toolbar:inline"
          >
            <EyeOff className="size-4 text-sm" />
          </ToolBarButton>
        )}
      </VisibleFields>
      <ViewFilter filters={view?.filter || null} onChange={onFilterChange}>
        {(text, isActive) => (
          <ToolBarButton
            disabled={disabled}
            isActive={isActive}
            text={text}
            className={cn(
              GUIDE_VIEW_FILTERING,
              'max-w-xs',
              isActive &&
                'bg-violet-100 dark:bg-violet-600/30 hover:bg-violet-200 dark:hover:bg-violet-500/30'
            )}
            textClassName="@2xl/toolbar:inline"
          >
            <FilterIcon className="size-4 text-sm" />
          </ToolBarButton>
        )}
      </ViewFilter>
    </div>
  );
};
